export const CREW_MEMBER_SEARCH_TEXT = {
	searchLabel: 'Driver for temporary replacement',
	searchPlaceholder: 'Search by name or driver ID',
	toggleLabel: 'Toggle',
	resultsAriaLabel: 'Crew member search results',
	inactive: 'Inactive',
	id: 'ID',
	activeDriversGroup: (count) => `ACTIVE DRIVERS (${count}):`,
	inactiveDriversGroup: (count) => `INACTIVE DRIVERS (${count}):`,
};
